import * as React from 'react';
import { useSelector } from 'react-redux';

import { EarlyAccessPaywallProvider as Provider } from 'shared/common/packages/EarlyAccessPaywall';
import { ESource } from 'shared/common/packages/EarlyAccessPaywall/shared/types/context';

import { selectUser } from '../../selectors/user';
import { getEarlyAccessPaywallMicrofrontend } from '../../services/getEarlyAccessPaywallMicrofrontend/getEarlyAccessPaywallMicrofrontend';
import { useApplicationContext } from '../ApplicationContext';

type EarlyAccessPaywallProviderProps = React.PropsWithChildren<{}>;

export const EarlyAccessPaywallProvider: React.FC<EarlyAccessPaywallProviderProps> = ({ children }) => {
  const context = useApplicationContext();
  const fetchManifest = React.useCallback(async () => getEarlyAccessPaywallMicrofrontend(context), [context]);

  const user = useSelector(selectUser);
  const isAuthenticated = user.isAuthenticated;

  const params = {
    isAuthenticated,
    source: ESource.Map,
  };

  return (
    <Provider fetchManifest={fetchManifest} params={params}>
      {children}
    </Provider>
  );
};
